import { CR_SUBMISSION } from '../constants';

export type SetRatingHintParams = {
    ratingHint: string;
    rootElement: Pick<HTMLElement, 'querySelector'>;
};
export const setRatingHint = ({ ratingHint, rootElement }: SetRatingHintParams) => {
    const hintSpan = rootElement.querySelector<HTMLSpanElement>(CR_SUBMISSION.STAR_RATING.HINT_SELECTOR);
    if (hintSpan === null) return;
    hintSpan.innerText = ratingHint;
};
